import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Loan } from '../loans';
import { environment } from '../../../environments/environment';

import { Repayment } from '../loans';
import { LoanService } from '../loans.service';
import { NachRepayment, EmiDue } from '../loans';
import { UtilService } from './utils.service';

@Component({
  selector: 'zest-loan-card',
  templateUrl: './loans-card.component.html',
  styleUrls: ['./loans-card.component.scss']
})

export class LoanCardComponent implements OnInit, OnChanges {

    @Input() viewType: string;
    @Input() Loan: Loan[];
    @Output() hideCards = new EventEmitter<boolean>();
    @Output() triggerSMSLink = new EventEmitter();
    public logoBaseUrl: string;
    public otherEmiDues: any[];
    public nextEmiDueIndex: number;
    public otherEmiShifted = false;
    public pendingTextBelowQuickPay = '';
    public arrearTextBelowQuickPay = '';
    public amountToPay: number;
    public showDetails = false;
    public lateFees: number;
    public selectedLoan: Loan[];
    public checkedEmi: any[];
    public transactionId = '';
    public transactionStatus = 'payment-status pending';
    public quickPayClicked = false;
    public mambuId: string;
    public selectedLoanRepayment: Loan;
    public showPaymentStatus = false;
    public nextEmiDue = new EmiDue();

    constructor(
        private nachService: LoanService,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.logoBaseUrl = environment.s3BucketUrl;
        if (this.Loan && this.Loan.length > 0) {
            this.getNachRepaymentStatus();
        }
    }

    ngOnChanges() {
        this.utilService.otherEmiShiftedSource.subscribe(value => {
            this.otherEmiShifted = value;
        });
        this.utilService.arrearTextBelowQuickPaySource.subscribe(value => {
            this.arrearTextBelowQuickPay = value;
        });
        this.utilService.pendingTextBelowQuickPaySource.subscribe(value => {
            this.pendingTextBelowQuickPay = value;
        });
    }

    getNachRepaymentStatus() {
        this.Loan.forEach(loan => {
        this.nextEmiDue = this.utilService.getNextEmiDue(loan.Repayments);
        this.otherEmiDues = this.utilService.getOtherEmiDues(loan.Repayments);
        this.nachService.getNachRepayment(loan.LoanExternalId).subscribe(result => {
            loan.nachRepayment = result[Object.keys(result).length - 1];
            loan.nachRepaymentError = false;
            loan = this.getNachStatus(loan);
            }, error => {
            loan.nachRepaymentError = true;
            loan.nachRepayment = new NachRepayment();
            loan = this.getNachStatus(loan);
            if (loan.Status !== 'InArrears') {
                loan.nachRepayment.FailureReason = 0;
            }
            });
        });
    }

    showStatus(loan) {
    if ((loan.Status === 'Approved') && loan.MerchantDetails) {
        return 'Activation Pending';
    } else {
        return loan.Status;
    }
    }

    getLoanAmount(loan) {
    if (this.viewType === 'Active') {
        if (loan.Repayments) {
        const nextLoan = loan.Repayments.find(loan => {
            return (loan.State !== 'Paid');
        });
        return (nextLoan === undefined) ? 0 : Math.round(nextLoan.PrincipalDue + nextLoan.InterestDue);
        } else {
        return Math.round(loan.EmiAmount);
        }
    } else {
        if (loan.Status === 'PaidOff') {
        return Math.round(loan.LoanAmount);
        } else {
        return 0;
        }
    }
    }

    getPaidEmis(repayments: Repayment[]): number {
    let month = 0;
    if (repayments && repayments.length > 0) {
        for (let i = 0; i < repayments.length; i++) {
        month = repayments[i].No;
        if (repayments[i].State.toLowerCase() !== 'paid') {
            month = month - 1;
            break;
        }
        }
    }
    return month;
    }

    getnextDueDate(data: any[]): string {
    let nextDueDate = null;
    const d = new Date();
    d.setHours(0, 0, 0);
    for (let i = 0; i < data.length; i++) {
        const d1 = new Date(data[i].DueDate);
        d1.setHours(23, 59, 59);
        if (data[i].State.toLowerCase() !== 'paid') {
        nextDueDate = data[i].DueDate;
        break;
        }
    }
    return nextDueDate;
    }

    getNachStatus(loan) {
        this.amountToPay = this.utilService.getAmountToPay(this.nextEmiDue, this.otherEmiDues);
        return loan;
    }

    showLoanDetails(loan) {
        this.selectedLoan = loan;
        this.showDetails = true;
        this.hideCards.emit(true);
    }
    onValueUpdated(newValue) {
        this.showDetails = newValue;
        this.hideCards.emit(false);
    }
    triggerSMS() {
        this.triggerSMSLink.emit();
    }
}
